import React, { useEffect, useState } from 'react';
const PURCHASES = [{
  name: 'María L.',
  province: 'Buenos Aires',
  product: 'MEGAPACK Código Fértil'
}, {
  name: 'Carolina S.',
  province: 'Córdoba',
  product: 'MEGAPACK Código Fértil'
}, {
  name: 'Valentina R.',
  province: 'Santa Fe',
  product: 'MEGAPACK Código Fértil'
}, {
  name: 'Luciana M.',
  province: 'Mendoza',
  product: 'MEGAPACK Código Fértil'
}, {
  name: 'Florencia G.',
  province: 'Tucumán',
  product: 'MEGAPACK Código Fértil'
}, {
  name: 'Romina P.',
  province: 'Entre Ríos',
  product: 'MEGAPACK Código Fértil'
}, {
  name: 'Agustina D.',
  province: 'Salta',
  product: 'MEGAPACK Código Fértil'
}, {
  name: 'Camila T.',
  province: 'Neuquén',
  product: 'MEGAPACK Código Fértil'
}, {
  name: 'Daniela F.',
  province: 'Misiones',
  product: 'MEGAPACK Código Fértil'
}, {
  name: 'Sofía B.',
  province: 'Chaco',
  product: 'MEGAPACK Código Fértil'
}];
function getRandomMinutes() {
  return Math.floor(Math.random() * 25) + 3;
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [minutes, setMinutes] = useState(getRandomMinutes());
  useEffect(() => {
    const initialDelay = setTimeout(() => setVisible(true), 8000);
    return () => clearTimeout(initialDelay);
  }, []);
  useEffect(() => {
    if (!visible) return;
    const hideTimer = setTimeout(() => {
      setVisible(false);
      const nextDelay = Math.floor(Math.random() * 8000) + 12000;
      const showTimer = setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % PURCHASES.length);
        setMinutes(getRandomMinutes());
        setVisible(true);
      }, nextDelay);
      return () => clearTimeout(showTimer);
    }, 5000);
    return () => clearTimeout(hideTimer);
  }, [visible, currentIndex]);
  const purchase = PURCHASES[currentIndex];
  return <div className={`fixed bottom-4 left-4 z-[60] max-w-xs transition-all duration-500 ease-out ${visible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0 pointer-events-none'}`} data-id="element-230">
      <div className="bg-white border border-brand-border-soft rounded-xl p-3.5 shadow-medium backdrop-blur-sm" data-id="element-231">
        <div className="flex items-start gap-3" data-id="element-232">
          <div className="w-9 h-9 rounded-full bg-brand-primary border border-brand-border-soft flex items-center justify-center flex-shrink-0" data-id="element-233">
            <span className="text-sm" data-id="element-234">🌸</span>
          </div>
          <div className="min-w-0" data-id="element-235">
            <p className="text-brand-heading text-sm font-semibold leading-tight" data-id="element-236">
              {purchase.name}
              <span className="text-brand-soft font-normal" data-id="element-237"> de </span>
              <span className="text-brand-cta" data-id="element-238">{purchase.province}</span>
            </p>
            <p className="text-brand-body text-xs mt-0.5" data-id="element-239">
              adquirió{' '}
              <span className="text-brand-heading font-medium" data-id="element-240">
                {purchase.product}
              </span>
            </p>
            <p className="text-brand-soft text-[10px] mt-1" data-id="element-241">
              hace {minutes} minutos
            </p>
          </div>
        </div>
      </div>
    </div>;
}